import React from 'react';
import PropTypes from 'prop-types';

import { reduxForm, formValueSelector, Field, isInvalid } from 'redux-form';
import { compose, lifecycle } from 'recompose';
import { connect } from 'react-redux';

import {
  FormGroup,
  ControlLabel,
  Col,
  Row,
} from 'react-bootstrap';

import LeaseInput from '../../../fields/LeaseInput';
import OperatorInput from '../../../fields/OperatorInput';
import { enableLookupFeature } from '../../../configuration/selectors';

export const FORM_NAME = 'jobEditorForm';

export const getJobFormState = (state) => {
  return {
    invalid: isInvalid(FORM_NAME)(state),
  };
};

/* eslint-disable react/forbid-prop-types, react/require-default-props */
const propTypes = {
  onSubmit: PropTypes.func.isRequired,
  operatorObj: PropTypes.object,
  enableLookup: PropTypes.bool.isRequired,
  lookupJoinType: PropTypes.oneOf(['user_records', 'lookup_records', 'union']).isRequired,
};

/* eslint-disable */
const createRenderer = (render) => ({ input, meta, label, ...rest }) => {
  return (
    <div
      className={[
        meta.error && meta.touched ? 'form-error' : '',
        meta.active ? 'form-active' : '',
      ].join(' ')}
    >
      <ControlLabel>
        {label}
      </ControlLabel>

      {render(input, label, rest)}

      {meta.error && meta.touched &&
      <span>
        {meta.error}
      </span>
      }
    </div>
  );
};

const validate = (values, props) => {
  const errors = {};
  if (!values.operator) {
    errors.operator = 'Required';
  }
  if (!values.lease) {
    errors.lease = 'Required';
  }
  return errors;
};

const RenderOperator = createRenderer((input, label, { disabled, enableLookup }) => {
  return (
    <OperatorInput
      lookupJoinType="user_records"
      enableLookup={enableLookup}
      disabled={disabled}
      {...input}
    />
  );
});

const RenderLease = createRenderer((input, label, { disabled, operator, lookupJoinType }) => {
  return (
    <LeaseInput
      operator={operator}
      disabled={disabled}
      lookupJoinType={lookupJoinType}
      {...input}
    />
  );
});

const JobForm = (props) => {
  const {
    lookupJoinType,
    enableLookup,
    submitting,
    invalid,
    pristine,
  } = props;
  const { operatorObj } = props;
  const disableLease = operatorObj === null;

  return (
    <form onSubmit={props.handleSubmit(props.onSubmit)} id={FORM_NAME}>
      <FormGroup>
        <Row>
          <Col xs={6}>
            <FormGroup>
              <Field
                name="operator"
                type="select"
                label="Operator"
                enableLookup={enableLookup}
                lookupJoinType="user_records"
                component={RenderOperator}
                // This makes sure that value is not cast to a string
                format={null}
              />
            </FormGroup>
          </Col>
          <Col xs={6}>
            <FormGroup>
              <Field
                name="lease"
                type="select"
                label="Lease"
                enableLookup={enableLookup}
                lookupJoinType={lookupJoinType}
                disabled={disableLease}
                component={RenderLease}
                operator={operatorObj}
                format={null}
              />
            </FormGroup>
          </Col>
        </Row>
      </FormGroup>
    </form>
  );
};

const withForm = reduxForm({
  form: FORM_NAME,
  enableReinitialize: true,
  validate,
});

const selector = formValueSelector(FORM_NAME);

const withRedux = connect((state) => {
  const operatorObj = selector(state, 'operator');
  const leaseObj = selector(state, 'lease');
  const lookupJoinType = enableLookupFeature(state) ? 'union' : 'user_records';
  const enableLookup = enableLookupFeature(state);

  return {
    operatorObj,
    leaseObj,
    lookupJoinType,
    enableLookup,
  };
});

const checkIfObjectChanged = (prevObject, nextObject) => {
  if (prevObject !== nextObject) {
    return true;
  } else if (prevObject && !nextObject) {
    return true;
  }
  return false;
};

const handleFieldChangeRelationship = lifecycle({
  componentWillReceiveProps(nextProps) {
    const {
      operatorObj: nextOperator,
    } = nextProps;

    const {
      operatorObj,
    } = this.props

    if (checkIfObjectChanged(operatorObj, nextOperator)) {
      this.props.change('lease', null);
    }
  },
});

JobForm.propTypes = propTypes;

const enhance = compose(
  withForm,
  withRedux,
  handleFieldChangeRelationship,
);

export default enhance(JobForm);
